import { lazy } from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

const ProductDashboard = lazy(
  () => import('@/features/produtos/pages/produto-painel'),
)
const ProductCreate = lazy(
  () => import('@/features/produtos/pages/produto-criar'),
)
const ProductEdit = lazy(
  () => import('@/features/produtos/pages/produto-editar'),
)
const ProductList = lazy(
  () => import('@/features/produtos/pages/produto-listar'),
)

export function ProductInternalRoutes() {
  return (
    <Routes>
      <Route index element={<ProductList />} />
      <Route path="novo" element={<ProductCreate />} />
      <Route path=":product_id" element={<Outlet />}>
        <Route index element={<ProductDashboard />} />
        <Route path="editar" element={<ProductEdit />} />
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  )
}
